import React from 'react';
import Layout from "../components/layout";
import Subheader from "../components/subheader";
import SEO from "../components/seo";
import {About} from '../components/about';
import Theme from "../styles/theme";

const AboutPage = ({location}) => {
  return (
    <Layout bigHeader={false}>
      <SEO
        location={location}
        title={`About`}
        type={`Series`}
      />
      <About />
    </Layout>
  );
}
export default AboutPage;
